'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.logServerErrorWithLoggingService = exports.ErrorFieldConst = exports.ErrorConst = undefined;

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var logServerErrorWithLoggingService = exports.logServerErrorWithLoggingService = function () {
  var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(error, stack, code) {
    var correlationId = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'No API calls were involved in the error';
    var reqUrl = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 'Unknown';
    var deviceId = arguments[5];
    var userInfo = arguments[6];
    var errorStack, customError;
    return _regenerator2.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!error.stack && !stack) {
              errorStack = {};

              Error.captureStackTrace(errorStack, logServerErrorWithLoggingService);
              stack = errorStack.stack;
            }

            customError = {
              error: (0, _extends3.default)({
                service: 'universal login'
              }, deviceId && { deviceId: deviceId }, userInfo && userInfo.loginId && { loginIdentityId: userInfo.loginId }, {
                message: error.message || error.statusText || error,
                stack: error.stack || stack,
                code: code,
                correlationId: correlationId,
                reqUrl: reqUrl
              })
            };
            _context.prev = 2;

            console.error(customError);
            _context.next = 6;
            return _axios2.default.post(_config2.default.errorLogUrl + '/log/universal-login/' + code, customError, {
              headers: {
                'Content-type': 'application/json',
                apiKey: _config2.default.loggerApiKey
              }
            });

          case 6:
            _context.next = 11;
            break;

          case 8:
            _context.prev = 8;
            _context.t0 = _context['catch'](2);

            console.log('logging error: ', _context.t0);

          case 11:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, this, [[2, 8]]);
  }));

  return function logServerErrorWithLoggingService(_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}();

exports.logError = logError;
exports.logErrorWithStackTrace = logErrorWithStackTrace;

var _axios = require('axios');

var _axios2 = _interopRequireDefault(_axios);

var _config = require('../config');

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ErrorConst = exports.ErrorConst = {
  ExpiredSecuredToken: 'EXPIRED_SECURED_TOKEN',
  InvalidValue: 'INVALID_VALUE',
  SessionWithoutUser: 'SESSION_WITHOUT_USER',
  FieldEmpty: 'FIELD_EMPTY',
  InvalidCaptcha: 'INVALID_CAPTCHA',
  GracePeriodUsed: 'GRACE_PERIOD_USED',
  FailedToLink: 'FAILED_TO_LINK',
  SocialLoginMissingEmail: 'SOCIAL_LOGIN_MISSING_EMAIL',
  UserNameAlreadyExists: 'USERNAME_ALREADY_EXISTS'
};

var ErrorFieldConst = exports.ErrorFieldConst = {
  EmailPassword: 'email-password',
  AccessToken: 'access_token',
  Password: 'password',
  SessionId: 'sessionId',
  Token: 'token'
};

function logError(errorString) {
  console.log('Error : ' + errorString);
}

function logErrorWithStackTrace(error) {
  console.log('Error : ' + error.statusText + '\n' + error.stack);
}


//////////////////
// WEBPACK FOOTER
// ./src/helpers/Error.js
// module id = 44
// module chunks = 0